<template>
  <div class="company">
    <el-form :model="form" ref="myForm" :rules="rules" hide-required-asterisk>
      <el-form-item
        v-if="viewType != 'search' && applicationType == 'RENEW'"
        :label="$t('message.validate_type')"
        prop="type"
      >
        <el-select
          v-model="form.type"
          value-key="code"
          filterable
          @change="changeType"
        >
          <el-option
            v-for="item in type"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- sp編號 -->
      <el-form-item
        v-if="applicationType == 'FIRST' || form.type == 'spNo'"
        :label="$t('message.spNo')"
        prop="spNo"
      >
        <el-input
          v-model="form.spNo"
          :placeholder="$t('message.spNo_placeholder')"
          :disabled="viewType == 'search'"
        ></el-input>
      </el-form-item>
      <!-- 車輛的註冊編號 -->
      <el-form-item
        v-if="form.type == 'registrationNo'"
        :label="$t('message.DataRegistration.Vehicle.registNoAndIdNo')"
        prop="regAndIdNo"
      >
        <el-input
          :placeholder="
            $t('message.DataRegistration.Vehicle.registNoAndIdNo_plh')
          "
          ref="registrationNo"
          v-model="form.regAndIdNo"
          class="input-with-select"
          @focus="onRegistNoFocus"
        ></el-input>
      </el-form-item>
      <!-- 配額公司的商業登記類型 -->
      <el-form-item
        :label="$t('message.Verification.company.macau_company_type')"
        prop="companyType"
      >
        <el-select
          v-model="form.companyType"
          filterable
          :placeholder="
            $t('message.Verification.company.macau_company_type_plh')
          "
        >
          <el-option
            v-for="item in companyType"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
        <!-- 配額公司的商業登記編號 -->
      </el-form-item>
      <el-form-item
        :label="$t('message.Verification.company.companyBrNo')"
        prop="companyNo"
      >
        <slot name="label">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('message.companyBrNo_tooltips')"
            placement="bottom"
          >
            <i class="el-icon-warning-outline warn-icon"></i>
          </el-tooltip>
        </slot>
        <el-input
          v-model="form.companyNo"
          :placeholder="$t('message.Verification.company.companyBrNo_plh')"
        ></el-input>
      </el-form-item>
      <!-- 本澳流動電話(用於短訊通知) -->
      <el-form-item
          v-if="isGHCompany"
          :label="$t('hzmbChange.label.mobile')"
          prop="mobile"
          :rules="[
            {
              required: true,
              message: $t('message.formRuleMessage.notNull'),
            },
            {
              pattern:
                form.mobileAreaCode === '853'
                  ? /^[6]{1}[0-9]{7}$/
                  : /^[0-9]{8}$/,
              message: $t('message.formRuleMessage.macauMobile'),
              trigger: 'blur',
            },
          ]"
        >
          <div class="m-mobile_row">
            <el-select
              v-model="form.mobileAreaCode"
              :placeholder="$t('hzmbG.label.mobileAreaCode')"
            >
              <el-option
                v-for="item in areas"
                :key="item.value"
                :value="item.value"
                :label="item.text"
              ></el-option>
            </el-select>
            <el-input
              v-model.number="form.mobile"
              :placeholder="$t('hzmbChange.message.drvMobile')"
              maxlength="8"
            ></el-input>
          </div>
        </el-form-item>
      <el-form-item v-else :label="$t('message.Verification.mobile')" prop="mobile">
        <el-input
          v-model="form.mobile"
          :placeholder="$t('message.Verification.mobile_placeholder')"
          maxlength="8"
        ></el-input>
      </el-form-item>
      <!-- 驗證碼 -->
      <el-form-item
        :label="$t('message.Verification.phone_code')"
        prop="captcha"
      >
        <div class="captcha_row" style="width: 100%">
          <el-input
            v-model="form.captcha"
            :placeholder="$t('message.Verification.phone_code_placeholder')"
            @keyup.enter.native="submit"
          ></el-input>
          <el-button
            v-show="show"
            type="primary"
            class="getVerify_btn"
            @click="getCode"
            :disabled="!this.form.mobile"
            :loading="getCodeLoading"
            >{{ $t("message.get_phone_code") }}</el-button
          >
          <el-button
            v-show="!show"
            type="primary"
            class="getVerify_btn"
            disabled
            >{{ count }}{{ $t("message.second") }}</el-button
          >
        </div>
      </el-form-item>
      <el-form-item class="submit_btn">
        <GradientBtn @click="submit" :loading="loading">{{
          $t("message.verify_submit")
        }}</GradientBtn>
      </el-form-item>
    </el-form>
    <!-- 註冊編號和車身編號彈窗 -->
    <RegistrationNoDialog
      v-if="showRegistrationNoDialog"
      @save="registNoSave"
      @close="showRegistrationNoDialog = false"
    ></RegistrationNoDialog>
  </div>
</template>

<script>
import i18n from "../../../public/lang/index";
import GradientBtn from "../../components/GradientBtn";
import LoginAPI from "../../api/LoginAPI";
import RegistrationNoDialog from "../../components/RegistrationNoDialog";
import HzmbMoRenewApplicationAPI from "@/api/HzmbMoRenewApplicationAPI";
import { checkServerStatus } from "@/util/util";
import { applicationTypeFilter } from "@/filters";
import HzmbVehDriApplicationChangeAPI from '@/api/HzmbVehDriApplicationChangeAPI';
export default {
  components: { GradientBtn, RegistrationNoDialog },
  data() {
    let validcodeMacauMobile = (rule, value, callback) => {
      // 驗證澳門手機
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.macauMobile")));
      } else {
        callback();
      }
    };
    let validcodeCompanyNo = (rule, value, callback) => {
      // 驗證配額公司的商業登記編號
      let check = true;
      let num = Number(value);
      if (num < 0 || isNaN(num)) {
        check = false;
      }
      if (value && !check) {
        callback(new Error(i18n.t("message.formRuleMessage.companyNo")));
      } else {
        callback();
      }
    };
    return {
      show: true,
      loading: false,
      getCodeLoading: false,
      timer: null,
      count: "",
      rules: {
        type: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        spNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          { max: 10, message: i18n.t("message.formRuleMessage.maxLength10") },
        ],
        regAndIdNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        companyType: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "change",
          },
        ],
        companyNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.companyNo"),
          },
          { max: 50, message: i18n.t("message.formRuleMessage.maxLength50") },
          { validator: validcodeCompanyNo, trigger: "blur" },
        ],
        mobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          { validator: validcodeMacauMobile, trigger: "blur" },
        ],
        captcha: [
          {
            max: 10,
            message: i18n.t("message.formRuleMessage.maxLength10"),
            trigger: "blur",
          },
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
        ],
      },
      showRegistrationNoDialog: false,
      type: [
        { code: "spNo", label: "message.spNo" },
        {
          code: "registrationNo",
          label: "message.DataRegistration.Vehicle.registrationNo",
        },
      ],
      companyType: [
        {
          code: "CO",
          label: "message.companyTypeCO",
        },
        {
          code: "EM",
          label: "message.companyTypeEM",
        },
        {
          code: "SO",
          label: "message.companyTypeSO",
        },
      ],
      areas: [
        { value: "853", text: i18n.t("hzmbG.enum.areas.macau") },
        { value: "852", text: i18n.t("hzmbG.enum.areas.hongkong") },
      ],
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
    serviceType() {
      return this.$store.state.serviceType;
    },
    applicationType() {
      const serviceType = this.$store.state.serviceType;
      return applicationTypeFilter(serviceType);
    },
    viewType() {
      return this.$store.state.viewType;
    },
    isGHCompany() {
      return this.serviceType === "HZMB_GH_CHANGE_COMP";
    },
  },
  methods: {
    getCode() {
      this.rules.captcha.splice(1, 1);
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            const mobileAreaCode = this.form.mobileAreaCode || '';
            const mobile = this.form.mobile;
            const serviceType = this.$store.state.serviceType;
            const spNo = this.form.spNo || null;
            const registrationNo = this.form.registrationNo || null;
            const identificationNo = this.form.identificationNo || null;
            if ((mobile && spNo) || (mobile && registrationNo)) {
              this.getCodeLoading = true;
              LoginAPI.captcha(
                `${mobileAreaCode}${mobile}`,
                serviceType,
                spNo,
                registrationNo,
                identificationNo
              )
                .then((res) => {
                  this.show = false;
                  this.getCodeLoading = false;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000);
                })
                .catch((err) => {
                  this.getCodeLoading = false;
                  this.$error(err);
                });
            } else {
              this.$message({
                type: "error",
                message: this.$t("message.spNoAndMobileFirst"),
              });
            }
          }
          this.rules.captcha.push({
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          });
        } else {
          this.rules.captcha.push({
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          });
        }
      });
    },
    submit() {
      this.$refs.myForm.validate(async (valid) => {
        if (valid) {
          const viewType = this.$store.state.viewType;
          const serviceType = this.$store.state.serviceType;
          const spNo = this.form.spNo || null;
          const registrationNo = this.form.registrationNo || null;
          const identificationNo = this.form.identificationNo || null;
          const companyType = this.form.companyType;
          const companyNo = this.form.companyNo;
          const mobileAreaCode = this.form.mobileAreaCode || '';
          const mobile = this.form.mobile;
          const captcha = this.form.captcha;
          const isFirst = viewType == "application" ? true : false;
          const changeType = this.form.changeType;
          if (
            ![
              "HZMB_FIRST_COMPANY",
              "HZMB_RENEW_COMPANY",
              "HZMB_MO_RENEW_COM",
              "HZMB_CHANGE_COMP",
              "HZMB_GH_CHANGE_COMP",
            ].includes(serviceType)
          ) {
            this.$message({
              type: "error",
              message: this.$t("message.different_login_type"),
            });
            this.$notify({
              type: "error",
              showClose: false,
              title: this.$t("message.tips"),
              message: this.$t("message.backToHome"),
              position: "bottom-right",
              duration: 4500,
            });
            setTimeout(() => {
              const page = localStorage.getItem("childTempTitle") || "one";
              if (page == "three") {
                this.$router.push("/entryTaxi");
              } else if (page == "two") {
                this.$router.push("/entryBus");
              } else {
                this.$router.push("/entry");
              }
            }, 5000);
            return;
          }
          if (
            ["HZMB_MO_RENEW_PERSON", "HZMB_MO_RENEW_COM"].includes(serviceType)
          ) {
            this.hzmbMoRenewCheck();
            return false;
          }
          try {
            const res = await LoginAPI.company(
              serviceType,
              spNo,
              registrationNo,
              identificationNo,
              companyType,
              companyNo,
              `${mobileAreaCode}${mobile}`,
              captcha,
              isFirst
            );
            // 清除form
            // const verifyForm = localStorage.getItem("verifyForm")
            //   ? JSON.parse(localStorage.getItem("verifyForm"))
            //   : null;
            // if (verifyForm && verifyForm.spNo != this.form.spNo) {
            localStorage.setItem("form", "");
            this.$store.commit("changeDocumentType", []);
            // }

            localStorage.setItem("verifyForm", JSON.stringify(this.form));
            localStorage.setItem("authentication", res.authentication);

            if (viewType === 'search' && ['HZMB_CHANGE_COMP', 'HZMB_GH_CHANGE_COMP'].includes(serviceType)) {
              await HzmbVehDriApplicationChangeAPI.check({
                serviceType,
                changeType,
                identType: companyType,
                identNo: companyNo,
                spNo,
                isFirst: false
              })
            }
            this.$router.replace(
              viewType == "search" ? "/search/status" : "/formData"
            );
          } catch (error) {
            this.$error(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },
    // 驗證澳門續期准入條件
    async hzmbMoRenewCheck() {
      const serviceType = this.$store.state.serviceType;
      const {
        spNo,
        registrationNo,
        identificationNo,
        companyType,
        companyNo,
        mobile,
        captcha,
      } = this.form;
      try {
        this.loading = true;
        await checkServerStatus(serviceType);
        const companyCheck = await LoginAPI.company(
          serviceType,
          spNo,
          registrationNo,
          identificationNo,
          companyType,
          companyNo,
          mobile,
          captcha
        );
        const data = await HzmbMoRenewApplicationAPI.check(
          serviceType,
          companyType,
          companyNo,
          spNo,
          registrationNo,
          identificationNo
        );
        localStorage.setItem("verifyForm", JSON.stringify(this.form));
        localStorage.setItem("authentication", companyCheck.authentication);
        this.$router.replace(
          `/formdata/hzmb-mo-renew/check/HZMB/${serviceType}/${data.id}`
        );
      } catch (error) {
        this.loading = false;
        this.$error(error);
      }
    },
    // 驗證車身註冊編號
    onRegistNoFocus() {
      this.$refs["registrationNo"].blur();
      this.showRegistrationNoDialog = true;
    },
    // 關閉註冊編號彈窗
    handleClose() {
      this.showRegistrationNoDialog = false;
    },
    // 註冊編號儲存
    registNoSave(data) {
      // console.log(data);
      // this.form.registrationNo = data.registrationNo;
      // this.form.identificationNo = data.identificationNo;

      const registrationNo = data.registrationNo;
      const identificationNo = data.identificationNo;
      // console.log(new Array(registrationNo.replace(/(.{2})/g, "$1,")));

      // 為字符串每個length個字，添加一條橫線
      // const xreplace = (str, length) => {
      //   if (str.indexOf("-") != -1) {
      //     return str;
      //   }
      //   // str = str.replace(/-/g, "");
      //   var re = new RegExp("[a-zA-Z]{1,2}|[0-9]{1," + length + "}", "g");
      //   var ma = str.match(re);
      //   // console.log("\\d{1," + length + "}");
      //   return ma.join("-");
      // };
      // const regAndIdNo = xreplace(registrationNo, 2);
      this.$set(this.form, "regAndIdNo", registrationNo);
      this.$set(this.form, "registrationNo", registrationNo);
      this.$set(this.form, "identificationNo", identificationNo);
      this.showRegistrationNoDialog = false;
    },
    changeType() {
      delete this.form.spNo;
      delete this.form.registrationNo;
      delete this.form.regAndIdNo;
      // this.$set(this.form, "spNo", null);
      // this.$set(this.form, "registrationNo", null);
      // this.$set(this.form, "regAndIdNo", null);
    },
  },
};
</script>

<style lang="scss" scoped>
.company {
}
.captcha_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.getVerify_btn {
  margin-left: 16px;
  min-width: 150px;
}
.warn-icon {
  font-size: 18px;
  line-height: 38px;
  cursor: pointer;
}
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 16px;
  }
}
</style>